import { LenderInputType, QuestionType } from './criteria-issue';

export enum EditContextStatus {
  DraftCreated,
  DraftUpdated,
  ContextUpdated,
}

export interface ContextOption {
  id: number;
  parentId?: number;
  questionText: string;
  questionDescription: string;
  lenderNodeText: string;
  hierarchyId: number;
  sourceQuestionText: string;
  questionId: number;
  flowType: string;
  contextNotes: string;
  editNodeId: number;
  live: boolean;
  internal: boolean;
  brokerVisible: boolean;
  lenderVisible: boolean;
  igniteVisible: boolean;
  verified: unknown;
  lowerRange?: number;
  upperRange?: number;
  value: string;
  sortOrder?: number;
  verifiedPercent? : number;
}

export interface CriteriaQuestionRequest {
  lenderText: string;
  brokerText: string;
  units: string;
  type: QuestionType;
  ordinal: number;
  questionNumber: number;
  lower?: number;
  upper?: number;
  options?: string[];
  intuitiveTag? : string;
  lenderInputType: LenderInputType;
}

export interface AddCriteriaContextRequest {
  name: string;
  lendingTypeIds: number[];
  issueId: number;
  questions: CriteriaQuestionRequest[];
  hasHadLiveVersion: boolean;
  hasMajorChanges: boolean;
}

export interface UpdateCriteriaContextResponse {
  status: EditContextStatus;
}

export interface RecentlyEditedContextResponse {
  criteriaContextId:number;
  criteriaContextName:string;
  criteriaIssueId:number;
  criteriaContextVersionId:number;
  criteriaContextLendingTypeId:number;
}

export interface RecentlyPublishedContexts {
  criteriaContextName:string;
  lenderContextCount:number;
}

export interface RecentlyPublishedContextsResponse {
  totalLendersCount:number;
  recentlyPublishedContexts:RecentlyPublishedContexts[];
}
